/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ExtensibleNode } from '../../core/models/ExtensibleNode';
import { IVisitor } from '../../core/visitors/IVisitor';
import { IOasVisitor } from '../visitors/IOasVisitor';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends ExtensibleNode
 */
export class OasXML extends ExtensibleNode {
    public name : string;

    public namespace : string;

    public prefix : string;

    public attribute : boolean;

    public wrapped : boolean;

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOasVisitor = <IOasVisitor><any>visitor;
        viz.visitXML(this);
    }

    constructor() {
        super();
        if(this.name===undefined) this.name = null;
        if(this.namespace===undefined) this.namespace = null;
        if(this.prefix===undefined) this.prefix = null;
        if(this.attribute===undefined) this.attribute = null;
        if(this.wrapped===undefined) this.wrapped = null;
    }
}
OasXML["__class"] = "io.apicurio.datamodels.openapi.models.OasXML";
OasXML["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




